var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DialogActions from '../../../../components/DialogActions';
var ModalDialog = function (props) {
    function closeModal() {
        props.setIsOpen(false);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "darkBG", onClick: closeModal }), _jsxs("div", __assign({ className: "modal" }, { children: [_jsx("div", __assign({ className: "modalHeader" }, { children: _jsx("h5", __assign({ className: "heading" }, { children: props.header })) })), _jsx("div", { className: "close", onClick: closeModal }), _jsx("div", __assign({ className: "modalContent" }, { children: props.content })), _jsx(DialogActions, { submitText: props.submitText, cancelText: props.cancelText, onSubmit: props.onSubmit, onCancel: closeModal })] }))] }));
};
export default ModalDialog;
